import { render, staticRenderFns } from "./spots.vue?vue&type=template&id=b6b1a950&"
import script from "./spots.vue?vue&type=script&lang=js&"
export * from "./spots.vue?vue&type=script&lang=js&"
import style0 from "./spots.vue?vue&type=style&index=0&id=b6b1a950&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports